import get from 'lodash/get'
import React from 'react'
import { Mutation } from 'react-apollo'
import CreatableSelect from '../../../common/select/CreatableSelect'
import { i18n } from '../../index'
import { addStationUser } from '../../station/stationQueries'
import type { Station, StationStore } from '../../station/stationTypes'
import type { User } from '../users/userTypes'
import css from './employeeForm.css'
type Option = {
  label: string
  value: string | null | undefined
}

const usersToOptions = (users: Array<User>, excludeIds: Array<string>): Array<Option> =>
  users
    .filter((user) => excludeIds.indexOf(user.id) === -1)
    .map((user) => ({
      label: user.name,
      value: user.id,
    }))

type EmployeeFormProps = {
  station: Station
  stationStore: StationStore
}

class EmployeeForm extends React.PureComponent<EmployeeFormProps> {
  onSubmit = (onMutate: (...args: Array<any>) => any, userId: string) => {
    const {
      station: { id: stationId },
    } = this.props
    onMutate({
      variables: {
        stationId,
        userId,
      },
    })
  }

  render() {
    const { station } = this.props
    return (
      <Mutation mutation={addStationUser}>
        {(onMutate) => (
          <div className={css.fields}>
            <CreatableSelect
              label={i18n.t('admin.stations.label.employee')}
              placeholder={i18n.t('admin.stations.label.employeePlaceholder')}
              onChange={({ value }) => {
                if (value) {
                  this.onSubmit(onMutate, value)
                }
              }}
              options={usersToOptions(
                get(station, 'company.users', []) as User[],
                (station.users || []).map((user) => user.id),
              )}
              isClearable={false}
              isSearchable={true}
              className={css.select}
            />
          </div>
        )}
      </Mutation>
    )
  }
}

export default EmployeeForm
